import React, { useEffect, useMemo, useState } from "react";
import _ from 'lodash';
import cx from "classnames";
import "cropperjs/dist/cropper.css";
import styles from "./crop.module.scss";
import useMeasure from "react-use-measure";

import Cropper, { ReactCropperElement } from "react-cropper";

import { useChain, useSpring, useSpringRef, animated, useTransition } from "@react-spring/web";
import { useDispatch } from "react-redux";

interface CropProps {
  headerDimension: { 
    width: number; 
    height: number 
  };
  children?: React.ReactNode;
  enabled: boolean;
  icon?: any;
  onCrop: (value: any) => void;
  loading: boolean;
  cropperDimensions: {
    width: string;
    height: string;
  },
  className?: string;
}

const Crop: React.FC<CropProps> = ({ enabled, headerDimension, icon, onCrop, loading, cropperDimensions, className }) => {
  const dispatch = useDispatch();
  const [editorRef, editorBounds] = useMeasure();
  const cropperRef = React.useRef<ReactCropperElement>(null);

  const [crop, setCrop] = React.useState<{ x: number, y: number, width: number; height: number } | null>(null);
  const [initialized, setInitialized] = React.useState(false);
  const [iconLoading, setIconLoading] = useState(true);


  useEffect(() => {
    if (enabled && editorBounds.height > 0) {
      setInitialized(true);
    }
  }, [editorBounds, enabled]);

  useEffect(() => {
    if (cropperRef.current && crop && enabled) {
      const cropper = cropperRef.current.cropper;
      const cropData = cropperRef.current!.cropper.getData();
      if (!cropper) {
        return;
      }

      onCrop(cropData);

    }
  }, [crop, enabled]);
  
  return (
    <div ref={editorRef} 
    className={cx(styles.editor, className)}
    >
      {(loading || iconLoading) && <div>Loading...</div>}
      <div className={styles.cropper}>
        <Cropper ref={cropperRef} src={icon} style={{
            maxWidth: cropperDimensions.width,
            maxHeight: cropperDimensions.height,
          }}
            zoomable={false}
            viewMode={1}
            guides={false}
            minContainerHeight={editorBounds.height}
            ready={(e) => {
              setIconLoading(false); 
              if(crop) {
                cropperRef.current!.cropper.setData(crop!);
              }
            }}
            data={crop ? {
              x: crop?.x || 0,
              y: crop?.y || 0,
              width: crop?.width || 100,
              height: crop?.height || 100,
            }: undefined}
            autoCrop={true}
            autoCropArea={1}
            crop={(e) => {
              setCrop(e.detail);
            }}
          />
          </div>
    </div>
  );
}

export { Crop };